import { Button } from '../Input2';
import { Alerts, General } from '../StrokeIcons';

import Popup, { type PopupProps } from './Popup';

type DeletePopupProps = PopupProps & {
  onDelete: () => void;
};

export default function DeletePopup({ onClose, onDelete }: DeletePopupProps) {
  return (
    <Popup onClose={onClose} className="max-w-sm p-0">
      <div className="flex flex-col items-center gap-2 px-5 pt-5">
        <div className="flex size-9 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/20">
          <Alerts.AlertTriangle className="size-4 text-red-600 dark:text-red-400" />
        </div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">Delete item</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Are you sure? This action cannot be undone.
        </p>
      </div>

      <div className="flex justify-end gap-2 px-5 py-4">
        <Button size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button size="sm" color="red" onClick={onDelete} icon={<General.Trash01 />}>
          Delete
        </Button>
      </div>
    </Popup>
  );
}
